import { IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IRoute } from '../../../../../core/interfaces/route.interface';
import { IMenuItemForageClass } from '../../../../../core/services/menu/menu-item-forage.service';
import { IMenuItemActionClass } from '../../../../../core/services/menu/menu-item-action.service';
import {  IStateService } from 'angular-ui-router';
import { INotificationHandler } from '../../../../../core/services/utils/notification-handler.service';

interface IPageAc2010 {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
}  
/* @ngInject */
export default function Ac2010Controller(
    Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass,
    MenuItemForage: IMenuItemForageClass,
    MenuItemAction: IMenuItemActionClass,
    notificationHandler: INotificationHandler,
    $state: IStateService,
    ac0010Route: IRoute,
    cp0005Route: IRoute,
) {

    const vm: IPageAc2010 = this;
    /**
     * CRÉATION DOCUEMENT D'ACHAT 
     * VIA ENTITÉ EXTERNE
     */
    const docAchatRef = new MenuItemAction(
        'LBL_DOC_REF',
        'BOU_MSG',
        (rowData: any) => ({
            refcleint: rowData.refcleint,
            intcleintreq: rowData.intcleintreq 
        }),
        {
            fonction: 'BTNDOCACHREF',
            icon: 'add_circle',
            iconButton: true,
            successAction: (response) => {
                response.response && 
                 notificationHandler.info({
                            lblMessage: response.response
                        });
                        /**
                         * forage vers ac0010
                         */
                $state.go(ac0010Route.NAME, {
                    refcleint: response.refcleint,
                    intcleintreq: response.intcleintreq,
                    type: 'ACSA',
                    menuId: $state.params.menuId
                });
            }
        }
    );
    //CP0005
    const DOcfournis = new MenuItemForage(
        '',
        cp0005Route.NAME,
        (rowData: any) => ({
            id: rowData.foucleint,
            refcleint: rowData.refcleint
        }),
        {
            fonction: 'BTNDOCFOUR',
            iconButton: true
        }
    );

    vm.multiOccurrenceOptions = {
        fonctions: {
            rechercheCollapsable: false,
            effaceCriteres: true,
            suiviModification: false
        },
        criteresSuggeres: new Formulaire([
            new FormulaireItem('intcleintreqcri', {
                required: true,
                largeur: 50
            }),
            new FormulaireItem('refcleintcri', { largeur: 50 }),
            new FormulaireItem('caacleintcri', { largeur: 50 }),
            new FormulaireItem('tfocleintcri', { largeur: 50 })
        ]),
        colonnesVisibles: [
            { nom: 'refcod', largeur: 190, menu: [docAchatRef, DOcfournis] },   
            { nom: 'caacod', largeur: 100 },
            { nom: 'caadsc', largeur: 200 }
        ],
        colonnesCachees: [
            'refcleint', 
            'caacleint',
            'intcleintreq',
            'foucleint'
        ]
    };
}